/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { PRIVACY_POLICY_URL } from '../../config';
import Content from './Content';

const { Paragraph } = Typography;

export default function TermsOfService() {
  const { t } = useTranslation();
  return (
    <Content title={t('termsOfService.title')}>
      <Paragraph>
        By signing up for Cupcake, you accept our <a href={PRIVACY_POLICY_URL}>Privacy Policy</a> and agree not to:
      </Paragraph>
      <ul>
        <li>Use our service to send spam or scam users.</li>
        <li>Promote violence or share illegal pornographic content.</li>
      </ul>
      <Paragraph>
        We reserve the right to update these Terms of Service later.
      </Paragraph>
      <Paragraph>
        Citizens of EU countries and the United Kingdom must be at least 16 years old to sign up.
      </Paragraph>
    </Content>
  );
}
